var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined",
    transform: "translate(-340 -244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Action",
    transform: "translate(100 100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-_-Action-_-copyright",
    "data-name": "Outlined-/-Action-/-copyright",
    transform: "translate(238 142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H24V24H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_-Icon-Color",
    "data-name": "\\uD83D\\uDD39-Icon-Color",
    d: "M10.08,10.86a2.557,2.557,0,0,1,.3-.87,1.749,1.749,0,0,1,.59-.62,1.775,1.775,0,0,1,.91-.23,1.813,1.813,0,0,1,.63.13,1.612,1.612,0,0,1,.52.36,1.926,1.926,0,0,1,.34.53,1.751,1.751,0,0,1,.14.64H15.3a3.58,3.58,0,0,0-.28-1.29,3,3,0,0,0-.7-1.01,3.266,3.266,0,0,0-1.08-.66,3.863,3.863,0,0,0-1.39-.23,3.908,3.908,0,0,0-1.7.34,3.439,3.439,0,0,0-1.2.92,3.759,3.759,0,0,0-.71,1.36A5.857,5.857,0,0,0,8,11.87v.27a5.855,5.855,0,0,0,.23,1.64,3.635,3.635,0,0,0,.71,1.35,3.414,3.414,0,0,0,1.2.91,4.058,4.058,0,0,0,1.7.34,3.814,3.814,0,0,0,1.32-.23,3.411,3.411,0,0,0,1.08-.63,3.052,3.052,0,0,0,.74-.94,2.691,2.691,0,0,0,.3-1.15H13.49a1.424,1.424,0,0,1-.15.58,1.472,1.472,0,0,1-.36.46,1.575,1.575,0,0,1-.52.3,1.986,1.986,0,0,1-.6.1,1.7,1.7,0,0,1-.89-.23,1.749,1.749,0,0,1-.59-.62,2.613,2.613,0,0,1-.3-.88,6.74,6.74,0,0,1-.08-1v-.27A6.663,6.663,0,0,1,10.08,10.86ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.011,8.011,0,0,1,12,20Z",
    fill: "#686868",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCIcons);
export default __webpack_public_path__ + "static/media/C_Icons.8a2d6b92b8eef7874e2f640503956ecd.svg";
export { ForwardRef as ReactComponent };